module.exports = __webpack_public_path__ + "img/bsmk1.1fd652cc.png";